export function formatDate(dateOrString: Date | string): string {
  const date =
    typeof dateOrString == "object" ? dateOrString : new Date(dateOrString);
  if (!date) return null;
  return date.toLocaleDateString();
}
